<button
  class="clarity-history-fab"
  [ngClass]="fabCorner"
  type="button"
  (click)="toggle()"
  [attr.aria-expanded]="isOpen"
  aria-label="Open history"
>
  History
</button>

<div
  class="clarity-history-overlay"
  [class.open]="isOpen"
  (click)="onBackdropClick()"
  role="dialog"
  aria-modal="true"
  [attr.aria-hidden]="!isOpen"
>
  <div class="clarity-history-panel" (click)="stopPropagation($event)">
    <div class="history-top-row">
      <div class="history-title-wrap">
        <div class="history-title">Saved history</div>
        <div class="history-subtitle" *ngIf="isLoggedIn">Recent conversations</div>
        <div class="history-subtitle" *ngIf="!isLoggedIn">Log in to view</div>
      </div>

      <button class="history-close-btn" type="button" (click)="close()" aria-label="Close history">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <div class="history-body">
      <div class="history-left">
        <div class="history-left-header">
          <div class="history-left-label">Dates</div>
        </div>

        <div class="history-left-list">
          <button
            class="history-date-btn"
            type="button"
            *ngFor="let g of groups"
            (click)="setActiveGroup(g.key)"
            [class.active]="g.key === activeGroupKey"
          >
            <span class="history-date-text">{{ g.label }}</span>
            <span class="history-date-count">{{ g.items.length }}</span>
          </button>

          <div class="history-empty" *ngIf="!loading && isLoggedIn && groups.length === 0">
            No history yet
          </div>
        </div>
      </div>

      <div class="history-right">
        <div class="history-right-header">
          <div class="history-search-wrap">
            <input
              class="history-search"
              type="text"
              [(ngModel)]="query"
              placeholder="Search history"
              aria-label="Search history"
            />
            <i class="fa-solid fa-magnifying-glass history-search-icon"></i>
          </div>
        </div>

        <div class="history-right-list">
          <div class="history-loading" *ngIf="loading">Loading...</div>

          <button
            class="history-item"
            type="button"
            *ngFor="let conv of activeItems"
            (click)="openConversation(conv.id)"
            [title]="conv.topic || 'Conversation'"
          >
            <div class="history-item-main">
              <div class="history-item-title">{{ truncate(conv.topic) }}</div>
              <div class="history-item-meta">
                <span class="history-item-time">{{ formatTime(conv.updatedAt) }}</span>
                <span class="history-dot">•</span>
                <span class="history-item-count" *ngIf="conv.messages?.length">
                  <i class="fa-solid fa-message"></i>
                  {{ conv.messages.length }}
                </span>
              </div>
            </div>
            <i class="fa-solid fa-chevron-right history-item-chevron"></i>
          </button>

          <div class="history-empty" *ngIf="!loading && isLoggedIn && activeItems.length === 0 && groups.length > 0">
            No matches
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
